export const buildFAQPage = (questions) => {
  const obj = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: buildMainEntity(questions),
  }
  //console.log('buildFAQPage', obj)
  return obj
}

export const buildMainEntity = (items) => {
  return items.map((el, id) => {
    return {
      "@type": "Question",
      name: el.title || el.name,
      acceptedAnswer: {
        "@type": "Answer",
        text: el.answer || el.content,
      },
    }
  })
}
